export const RAW_DATA = "全勤怠データ";
export const SUMMARY = "日別・従業員別勤怠実績";
export const PAYROLL = "給与計算ソフト向け勤務実績";
